var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.505005H6V2.505H12V0.505005ZM8 13.505H10V7.505H8V13.505ZM16.03 6.885L17.45 5.465C17.02 4.955 16.55 4.475 16.04 4.055L14.62 5.47501C13.07 4.23501 11.12 3.495 9 3.495C4.03 3.495 0 7.525 0 12.495C0 17.465 4.02 21.495 9 21.495C13.98 21.495 18 17.465 18 12.495C18 10.385 17.26 8.43501 16.03 6.885ZM9 19.505C5.13 19.505 2 16.375 2 12.505C2 8.635 5.13 5.505 9 5.505C12.87 5.505 16 8.635 16 12.505C16 16.375 12.87 19.505 9 19.505Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyTimeIcon);
export default __webpack_public_path__ + "static/media/surveyTimeIcon.941214f3a55d2e6780e4dc3295531ab5.svg";
export { ForwardRef as ReactComponent };